// extracted by mini-css-extract-plugin
module.exports = {"messageContent":"SmsHistory_messageContent__3jmIR"};